module.exports = __webpack_public_path__ + "static/img/onlineb.276a375.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/we/onlineb.jpg
 ** module id = 595
 ** module chunks = 2
 **/